import { render, staticRenderFns } from "./SuccesCreateEntranceInput.vue?vue&type=template&id=66bbb234&scoped=true"
import script from "./SuccesCreateEntranceInput.vue?vue&type=script&lang=js"
export * from "./SuccesCreateEntranceInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bbb234",
  null
  
)

export default component.exports